import {defineStore} from "pinia";
import axios from "axios";

export const usePaySectionStore = defineStore('paySection', {
    state: () => ({
        backupPaySection: {
            editable: false,
            notWritable: false,
            formule: null,
            regularization: "0",
            cotisable: "0",
            brute: "0",
            conge: "0",
            stateChargePrintable: "0",
            totauxPrintable: "0",
            recapPrintable: "0",
            journalPrintable: "0",
            blockFormula: "0",
            fixeInitial: "0",
            isAbsenceRetenue: false,
            relations: [],
        },
        paySection: {},
        paySections: [],
        loading: false,
    }),
    actions: {
        setLoading(loading) {
            this.loading = loading
        },
        setPaySection(paySection) {
            this.paySection = paySection
        },
        setPaySections(paySections) {
            this.paySections = paySections
        },
        addPaySection(paySection) {
            this.paySections.unshift(paySection)
        },
        updatePaySection(paySection) {
            let index = this.paySections.findIndex(cl => cl.id === paySection.id)
            this.paySections.splice(index, 1, paySection)
        },
        deletePaySection(paySection) {
            let index = this.paySections.findIndex(cl => cl.id === paySection.id)
            this.paySections.splice(index, 1)
        },
        findAll() {
            this.setLoading(true);
            axios.get(`/paySections`).then(response => {
                this.setPaySections(response.data);
            }).finally(() => {
                this.setLoading(false);
            });
        }
    },
});